import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IClinicsRes } from './index.type';

const useAllClinics = ({ pageNumber, perpageData }: { pageNumber: number; perpageData: number }) => {
  const [clinicsData, setClinicsData] = React.useState<IClinicsRes>();

  const { loading: clinicsDataLoading, makeApiCall } = useApi({
    url: `/clinic?page=${pageNumber}&limit=${perpageData}`,
    method: 'GET',
  });

  const getClinicsData = async () => {
    const { response, error } = await makeApiCall<undefined, IClinicsRes>();
    if (response?.status === 'success') {
      setClinicsData(response);
    }

    if (response?.status === 'fail') {
      setClinicsData(undefined);
    }

    if (error) toast.error(error.msg || 'Unable to load clinic data. Please refresh and try again.');
  };

  return {
    clinicsData,
    getClinicsData,
    clinicsDataLoading,
  };
};

export default useAllClinics;
